(function () {
  'use strict';

  var STORAGE_KEY = 'rh_wishlist';

  // -------------------------------------------------------------------------
  // localStorage helpers
  // -------------------------------------------------------------------------

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {}
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(productId);
    });
  }

  function toggleWishlist(productData) {
    var list = getWishlist();
    var idx  = -1;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(productData.id)) { idx = i; break; }
    }
    if (idx > -1) { list.splice(idx, 1); } else { list.push(productData); }
    saveWishlist(list);
    return idx === -1; // true = added
  }

  // -------------------------------------------------------------------------
  // Update all heart buttons + header badge to reflect current wishlist state
  // -------------------------------------------------------------------------

  function updateAllButtons() {
    var buttons = document.querySelectorAll('.rh-wishlist-btn[data-product-id]');
    buttons.forEach(function (btn) {
      var inList  = isInWishlist(btn.dataset.productId);
      btn.classList.toggle('rh-wishlist-btn--active', inList);
      var label   = btn.querySelector('.rh-wishlist-btn__label');
      if (label) label.textContent = inList ? 'Wishlisted' : 'Add to Wishlist';
    });
    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    var count  = getWishlist().length;
    var badges = document.querySelectorAll('.rh-wishlist-header-btn__badge');
    badges.forEach(function (badge) {
      badge.textContent = count > 0 ? count : '';
      badge.hidden      = count === 0;
    });
  }

  // -------------------------------------------------------------------------
  // Heart button click (product rows)
  // -------------------------------------------------------------------------

  function onWishlistBtnClick(e) {
    var btn = e.target.closest('.rh-wishlist-btn');
    if (!btn || !btn.dataset.productId) return;

    var sku = '';
    var variantId = '';
    var properties = {};
    var row = btn.closest('.js-product-card');
    if (row) {
      var variantInput = row.querySelector('.js-product-card-variant-input');
      var skuScript    = row.querySelector('.rh-variant-skus');
      if (variantInput) variantId = variantInput.value || '';
      if (variantInput && skuScript) {
        try {
          var skus = JSON.parse(skuScript.textContent);
          if (variantId && skus[variantId]) sku = skus[variantId];
        } catch (err) {}
      }
      // Capture all custom property selections (Finish, Leg Choice, Seat, etc.)
      row.querySelectorAll('select[data-custom-option]').forEach(function(sel) {
        if (sel.value && sel.value !== '') {
          var name = sel.getAttribute('data-option-name') || sel.getAttribute('data-custom-option') || '';
          if (name) properties[name] = sel.value;
        }
      });
    }

    toggleWishlist({
      id:           btn.dataset.productId,
      title:        btn.dataset.productTitle,
      url:          btn.dataset.productUrl,
      collectionUrl: window.location.href,
      image:        btn.dataset.productImage || '',
      price:        btn.dataset.productPrice || '',
      sku:          sku,
      variantId:    variantId,
      properties:   properties
    });
    updateAllButtons();
  }

  // -------------------------------------------------------------------------
  // Wishlist drawer
  // -------------------------------------------------------------------------

  var sharedItems = null; // non-null when viewing a shared wishlist

  var _scrollY = 0;

  function openDrawer() {
    var drawer = document.getElementById('rh-wishlist-drawer');
    if (!drawer) return;
    // Portal: move drawer to body so it's outside any header stacking context
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }
    renderDrawer();
    drawer.removeAttribute('hidden');
    // iOS-safe scroll lock: fix body in place so background doesn't scroll
    _scrollY = window.pageYOffset || 0;
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }

  function closeDrawer() {
    var drawer = document.getElementById('rh-wishlist-drawer');
    if (!drawer) return;
    drawer.setAttribute('hidden', '');
    // Restore scroll position exactly
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, _scrollY);
  }

  function renderDrawer(overrideList) {
    var itemsEl = document.getElementById('rh-wishlist-items');
    var emptyEl = document.querySelector('.rh-wishlist-drawer__empty');
    var banner  = document.getElementById('rh-wishlist-shared-banner');
    if (!itemsEl) return;

    var list = overrideList || getWishlist();
    var isShared = !!overrideList;
    itemsEl.innerHTML = '';

    if (banner) banner.hidden = !isShared;

    if (!list.length) {
      if (emptyEl) emptyEl.removeAttribute('hidden');
      return;
    }
    if (emptyEl) emptyEl.setAttribute('hidden', '');

    list.forEach(function (item) {
      var el = document.createElement('div');
      el.className = 'rh-wishlist-item';
      var imgHtml = item.image
        ? '<a href="' + item.url + '" class="rh-wishlist-item__img-link"><img class="rh-wishlist-item__img" src="' + item.image + '" alt="" loading="lazy"></a>'
        : '<div class="rh-wishlist-item__img-placeholder"></div>';
      el.innerHTML =
        imgHtml +
        '<div class="rh-wishlist-item__info">' +
          '<a href="' + item.url + '" class="rh-wishlist-item__title">' + item.title + '</a>' +
          (item.sku ? '<p class="rh-wishlist-item__sku">SKU: ' + item.sku + '</p>' : '') +
          '<p class="rh-wishlist-item__price">' + (item.price || '') + '</p>' +
          (function() {
            var props = item.properties || {};
            var keys  = Object.keys(props);
            if (!keys.length) return '';
            return '<div class="rh-wishlist-item__props">' +
              keys.map(function(k) {
                return '<p class="rh-wishlist-item__prop"><span class="rh-wishlist-item__prop-label">' + k + ':</span> ' + props[k] + '</p>';
              }).join('') +
              '</div>';
          })() +
          '<a href="' + item.url + '" class="rh-wishlist-item__shop">View Product</a>' +
          '<div class="rh-wishlist-item__atc-wrap">' +
            '<span class="rh-wishlist-item__atc-or">or</span>' +
            '<button type="button" class="rh-wishlist-item__atc"' +
              ' data-product-url="' + item.url + '"' +
              ' data-variant-id="' + (item.variantId || '') + '"' +
              ' data-properties="' + encodeURIComponent(JSON.stringify(item.properties || {})) + '"' +
            '>Add to Cart</button>' +
          '</div>' +
        '</div>' +
        (isShared ? '' : '<button class="rh-wishlist-item__remove" type="button" data-id="' + item.id + '" aria-label="Remove">&times;</button>');
      itemsEl.appendChild(el);
    });
  }

  // -------------------------------------------------------------------------
  // Share wishlist
  // -------------------------------------------------------------------------

  function encodeWishlist(list) {
    try {
      return btoa(unescape(encodeURIComponent(JSON.stringify(list))));
    } catch (e) { return ''; }
  }

  function decodeWishlist(str) {
    try {
      return JSON.parse(decodeURIComponent(escape(atob(str))));
    } catch (e) { return null; }
  }

  function getHandleFromUrl(url) {
    var match = (url || '').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  function generateShareUrl() {
    var list = getWishlist();
    if (!list.length) return null;
    var handles = list.map(function (item) { return getHandleFromUrl(item.url); }).filter(Boolean);
    if (!handles.length) return null;
    return window.location.origin + '/?wl=' + btoa(handles.join(','));
  }

  function onShareBtnClick(e) {
    if (!e.target.closest('#rh-wishlist-share-btn')) return;
    var url = generateShareUrl();
    if (!url) return;
    var labelEl = document.querySelector('.rh-wishlist-share-btn__label');
    var linkText = 'View my Wishlist from Old Hippy Wood Products';
    var htmlContent = '<a href="' + url + '">' + linkText + '</a>';
    var plainContent = linkText + ': ' + url;

    function onCopied() {
      if (labelEl) { labelEl.textContent = 'Copied!'; setTimeout(function () { labelEl.textContent = 'Share'; }, 2000); }
    }

    function fallbackCopy() {
      var ta = document.createElement('textarea');
      ta.value = plainContent;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      onCopied();
    }

    if (navigator.clipboard && window.ClipboardItem) {
      var htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      var textBlob = new Blob([plainContent], { type: 'text/plain' });
      navigator.clipboard.write([new ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob })])
        .then(onCopied)
        .catch(function () {
          navigator.clipboard.writeText(plainContent).then(onCopied).catch(fallbackCopy);
        });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(plainContent).then(onCopied).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  }

  function onSaveSharedClick(e) {
    if (!e.target.closest('#rh-wishlist-shared-save') || !sharedItems) return;
    var existing = getWishlist();
    sharedItems.forEach(function (item) {
      if (!existing.some(function (i) { return String(i.id) === String(item.id); })) {
        existing.push(item);
      }
    });
    saveWishlist(existing);
    sharedItems = null;
    updateAllButtons();
    renderDrawer();
    // Remove ?wl= from URL without reloading
    var url = new URL(window.location.href);
    url.searchParams.delete('wl');
    history.replaceState(null, '', url.toString());
  }

  function formatCents(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function checkSharedWishlist() {
    var params = new URLSearchParams(window.location.search);
    var wl = params.get('wl');
    if (!wl) return;

    var decoded;
    try { decoded = atob(wl); } catch (e) { return; }

    // Legacy format: full JSON array
    if (decoded.charAt(0) === '[') {
      try {
        var legacy = JSON.parse(decoded);
        if (legacy && legacy.length) { sharedItems = legacy; openDrawer(); renderDrawer(sharedItems); }
      } catch (e) {}
      return;
    }

    // New format: comma-separated product handles
    var handles = decoded.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    if (!handles.length) return;

    var results = new Array(handles.length);
    var pending = handles.length;

    function onResult(index, item) {
      results[index] = item;
      if (--pending === 0) {
        sharedItems = results.filter(Boolean);
        if (sharedItems.length) { openDrawer(); renderDrawer(sharedItems); }
      }
    }

    handles.forEach(function (handle, i) {
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          onResult(i, {
            id:            String(data.id),
            title:         data.title,
            url:           '/products/' + data.handle,
            collectionUrl: '/products/' + data.handle,
            image:         data.featured_image ? 'https:' + data.featured_image : '',
            price:         data.price_min ? formatCents(data.price_min) : ''
          });
        })
        .catch(function () { onResult(i, null); });
    });
  }

  function onDrawerAddToCart(e) {
    var btn = e.target.closest('.rh-wishlist-item__atc');
    if (!btn) return;
    var productUrl  = btn.dataset.productUrl;
    var variantId   = btn.dataset.variantId;
    var properties  = {};
    try { properties = JSON.parse(decodeURIComponent(btn.dataset.properties || '{}')); } catch(err) {}
    if (!productUrl) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    function doAdd(vid) {
      var payload = { id: Number(vid), quantity: 1 };
      if (Object.keys(properties).length > 0) payload.properties = properties;
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }

    function onSuccess() {
      btn.textContent = 'Added!';
      if (window.themeCore && window.themeCore.CartApi) {
        window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
      }
      setTimeout(function() { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 2500);
    }

    function onError() {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }

    if (variantId) {
      doAdd(variantId).then(onSuccess).catch(onError);
    } else {
      var parts  = productUrl.replace(/\?.*$/, '').split('/');
      var handle = parts[parts.length - 1];
      fetch('/products/' + handle + '.js', { credentials: 'include' })
        .then(function(r) { return r.json(); })
        .then(function(product) {
          var variant = (product.variants || []).find(function(v) { return v.available; });
          if (!variant) variant = (product.variants || [])[0];
          if (!variant) throw new Error('no variant');
          return doAdd(variant.id);
        })
        .then(onSuccess)
        .catch(onError);
    }
  }

  function onDrawerRemove(e) {
    var btn = e.target.closest('.rh-wishlist-item__remove');
    if (!btn) return;
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(btn.dataset.id);
    });
    saveWishlist(list);
    updateAllButtons();
    renderDrawer();
  }

  function onDrawerClose(e) {
    if (e.target.closest('.rh-wishlist-drawer__close') ||
        e.target.classList.contains('rh-wishlist-drawer__backdrop')) {
      closeDrawer();
    }
  }

  function onHeaderBtnClick(e) {
    if (e.target.closest('.rh-wishlist-header-btn')) {
      e.preventDefault();
      sharedItems = null;
      openDrawer();
    }
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') closeDrawer();
  }

  // -------------------------------------------------------------------------
  // Init
  // -------------------------------------------------------------------------

  function init() {
    document.addEventListener('click', onWishlistBtnClick);
    document.addEventListener('click', onHeaderBtnClick);
    document.addEventListener('click', onDrawerClose);
    document.addEventListener('click', onDrawerRemove);
    document.addEventListener('click', onDrawerAddToCart);
    document.addEventListener('click', onShareBtnClick);
    document.addEventListener('click', onSaveSharedClick);
    document.addEventListener('keydown', onKeyDown);
    updateAllButtons();
    checkSharedWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
